import { Constants } from '@constants';

export const getPageNameByPath = () => {
    const pathname = window.location.pathname;
    let page = pathname?.split('/')?.[2]?.toLowerCase()?.split('-') || "";
    if (page[0]?.length > 0) {
      for (var i = 0; i < page.length; i++) {
        page[i] = page[i]?.charAt(0)?.toUpperCase() + page[i]?.substring(1);
      }
      page = page?.join(' ');
    } else {
      page = Constants.DASHBOARD_LABEL;
    }
    return page;
};